export default "__VITE_ASSET__CE7XGRjE__"